export default __webpack_public_path__ + "static/media/eyec.2321d8ca.svg";